/**
 * Route Context Instance - Only the context is exported from here
 *
 * This file is separate to satisfy react-refresh which doesn't allow
 * mixing context exports with component exports.
 */

import { createContext } from 'react';
import type { PageUrls, RouteContextValue, UseGetPageUrl } from './types';

/**
 * Default useGetPageUrl that warns when context is not initialized
 */
const defaultUseGetPageUrl: UseGetPageUrl = () => {
  console.warn(
    'RouteContext not initialized. useGetPageUrl called before RouteProvider is set up. ' +
      'Make sure the main app wraps the component tree with RouteProvider.',
  );
  return {} as PageUrls;
};

/**
 * Default context value
 */
const defaultContextValue: RouteContextValue = {
  useGetPageUrl: defaultUseGetPageUrl,
};

/**
 * Route Context - The React Context instance
 */
export const RouteContext =
  createContext<RouteContextValue>(defaultContextValue);
